import React from 'react'
import { Props } from './types'

export const Card: React.FC<Props> = (props) => {
  return (
    <svg
      version="1.1"
      x="0px"
      y="0px"
      width="16px"
      height="16px"
      viewBox="0 0 16 16"
      {...props}
    >
      <path d="M11.82,1.37h-7.64c-.69,0-1.26.56-1.26,1.26v11.28c0,.69.56,1.26,1.26,1.26h7.64c.69,0,1.26-.56,1.26-1.26V2.63c0-.69-.56-1.26-1.26-1.26ZM11.79,7.24c0,.43-.35.78-.78.78h-6.01c-.43,0-.78-.35-.78-.78v-3.81c0-.43.35-.78.78-.78h6.01c.43,0,.78.35.78.78v3.81Z" />
    </svg>
  )
}
